export const editingLogicMixin = {
  data() {
    return {
      editingMode: false,
      errorMessage: '',
      showErrorAlert: false,
      apiLoadingData: false,
      formIsValid: true
    }
  },
  created() {
    this.initData()
  },
  methods: {
    addData(apiAdd) {
      this.apiLoadingData = true
      const apiData = this.newData()
      console.log('start adding data')
      apiAdd(apiData)
        .then(response => {
          this.setFreshData()
          this.errorMessage = ''
          this.apiLoadingData = false
          console.log('data addded')
          this.dataAdded(response.data)
        })
        .catch(error => {
          this.apiLoadingData = false
          console.log('data add error:', error)
          this.errorMessage =
            'Ой, ё, чот оно почему-то не добавляется. Какая-то ошибка: ' + error
          console.log(this.errorMessage)
        })
    },

    updateData(apiUpdate, apiDataId) {
      this.apiLoadingData = true

      const apiData = this.setData()
      console.log('start updating data')
      apiUpdate(apiDataId, apiData)
        .then(response => {
          this.editingMode = false
          this.showErrorAlert = false
          this.apiLoadingData = false
          //this.$refs.form.resetValidation()
          console.log('data updated')
          this.dataUpdated(response.data)
        })
        .catch(error => {
          this.apiLoadingData = false
          console.log('data update error:', error)
          this.errorMessage =
            'Ой, ё, почему-то ничо не сохраняется. Какая-то ошибка: ' + error
          this.showErrorAlert = true
        })
    },

    deleteData(apiDelete, apiDataId) {
      this.$refs.confirm
        .open('Точно удаляем?', 'Кто-то же это писал, старался, наверное ))', {
          color: 'red'
        })
        .then(confirm => {
          if (confirm) {
            this.apiLoadingData = true
            apiDelete(apiDataId)
              // eslint-disable-next-line no-unused-vars
              .then(response => {
                this.errorMessage = ''
                this.apiLoadingData = false
                this.dataDeleted(apiDataId)
              })
              .catch(error => {
                this.apiLoadingData = false
                this.errorMessage =
                  'Ой, ё, почему-то ничо не удаляется. Какая-то ошибка: ' +
                  error
                this.showErrorAlert = true
              })
          }
        })
    },
    dataDeleted(apiDataId) {
      this.$emit('deletedata', apiDataId)
    },
    dataUpdated(apiData) {
      console.log('DATA UPDATED in mixin', apiData)
      this.$emit('updatedata', apiData)
    },
    dataAdded(apiData) {
      this.$emit('adddata', apiData)
    },
    cancelEditing() {
      this.initData()
      this.editingMode = false
      this.showErrorAlert = false
      this.$refs.form.resetValidation()
    },
    initData() {}
  }
}
